import { Directive, HostListener, Input, ElementRef } from "@angular/core";

@Directive({
  selector: "[appOnlyNumbers]",
})
export class OnlyNumbersDirective {
  @Input() allowMultiLine: boolean;
  @Input() allowNegative: boolean;
  @Input() allowDecimal: boolean;
  @Input() maxLength: number;
  regex: RegExp;

  constructor(private el: ElementRef) {}

  @HostListener("keypress", ["$event"])
  onKeyPress(event: KeyboardEvent): void {
    this.validate(event, event.key === "Enter" ? "\n" : event.key);
  }

  @HostListener("paste", ["$event"])
  onPaste(event: Event): void {
    const pastedText =
      ((<any>window).clipboardData && (<any>window).clipboardData.getData("Text")) || // If IE, use window
      (<ClipboardEvent>event && (<ClipboardEvent>event).clipboardData.getData("text/plain")); // Non-IE browsers
    this.validate(event, pastedText);
  }

  @HostListener("cut", ["$event"])
  onCut(event: Event): void {
    this.validate(event, "");
  }

  validate(event: Event, text: string): void {
    const txtInput = this.el.nativeElement;
    const newValue =
      txtInput.value.substring(0, txtInput.selectionStart) + text + txtInput.value.substring(txtInput.selectionEnd);
    if (!this.regex) {
      this.regex = <RegExp>(
        eval("/^" + (this.allowNegative ? "-?" : "") + (this.allowDecimal ? "((\\d+\\.?)|(\\.?))\\d*" : "\\d*") + "$/g")
      );
    }
    const lines = this.allowMultiLine ? newValue.split("\n") : [newValue];
    for (const line of lines) {
      const lineText = line.replace("\r", "");
      if ((this.maxLength && lineText.length > this.maxLength) || !lineText.match(this.regex)) {
        event.preventDefault();
        return;
      }
    }
  }
}
